module.exports = {"371328001":"蒙阴街道","371328101":"常路镇","371328102":"岱崮镇","371328103":"坦埠镇","371328104":"垛庄镇","371328105":"高都镇","371328106":"野店镇","371328107":"桃墟镇","371328109":"联城镇","371328201":"旧寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371328.json
// module id = 1351
// module chunks = 0